var modules_7e6c94c2 = {"pixels":"_184aekl"};
import "../../assets/CiQhH0Fg.css";

export { modules_7e6c94c2 as default };
//# sourceMappingURL=pixel.module.scss.js.map
